import {
  FiCheckCircle,
  FiFacebook,
  FiInstagram,
  FiLink,
  FiLinkedin,
  FiTwitter,
  FiYoutube,
} from "react-icons/fi";

import team1 from "../assets/images/team/dr-carlos-guzman.jpg";
import team2 from "../assets/images/team/dr-jose-silva.jpg";
import team3 from "../assets/images/team/dr-fernando-pegueros.jpg";
// import team4 from '../assets/images/team/dra-victoria-bucio.jpg'
import team5 from "../assets/images/team/05.jpg";

import blog1 from "../assets/images/blog/1.jpg";
import blog2 from "../assets/images/blog/2.jpg";
import blog3 from "../assets/images/blog/3.jpg";
import blog4 from "../assets/images/blog/4.jpg";
import blog5 from "../assets/images/blog/5.jpg";
import blog6 from "../assets/images/blog/6.jpg";
import blog7 from "../assets/images/blog/7.jpg";
import blog8 from "../assets/images/blog/8.jpg";
import blog9 from "../assets/images/blog/9.jpg";

import instalaciones1 from "../assets/images/instalaciones/1.jpg";
import instalaciones2 from "../assets/images/instalaciones/2.jpg";
import instalaciones3 from "../assets/images/instalaciones/3.jpg";

import paquete1 from "../assets/images/paquetes/1.jpg";
import paquete2 from "../assets/images/paquetes/2.jpg";
import paquete3 from "../assets/images/paquetes/3.jpg";

import servicios1 from "../assets/images/servicios/1.jpg";
import servicios2 from "../assets/images/servicios/2.jpg";
import servicios3 from "../assets/images/servicios/3.jpg";

import servicio from "../assets/images/servicios/laboratorio.jpg";

import s1 from "../assets/images/especialidades/cardiology.svg";
import s2 from "../assets/images/especialidades/neurology.svg";
import s3 from "../assets/images/especialidades/orthopaedic.svg";
import s4 from "../assets/images/especialidades/gynecology.svg";
import s5 from "../assets/images/especialidades/dermatology.svg";
import s6 from "../assets/images/especialidades/urology.svg";
import s7 from "../assets/images/especialidades/nephrology.svg";
import s8 from "../assets/images/especialidades/radiology.svg";
import s9 from "../assets/images/especialidades/neonatology.svg";
import s10 from "../assets/images/especialidades/dentistry.svg";

import doctor1 from "../assets/images/team/01.jpg";
import doctor2 from "../assets/images/team/02.jpg";
import doctor3 from "../assets/images/team/03.jpg";
import doctor4 from "../assets/images/team/04.jpg";
import doctor5 from "../assets/images/team/05.jpg";
import doctor6 from "../assets/images/team/06.jpg";
import doctor7 from "../assets/images/team/07.jpg";
import doctor8 from "../assets/images/team/08.jpg";

import alianza1 from "../assets/images/alianzas/a1.jpg";
import alianza2 from "../assets/images/alianzas/a2.jpg";
import alianza3 from "../assets/images/alianzas/a3.jpg";
import alianza4 from "../assets/images/alianzas/a4.jpg";
import alianza5 from "../assets/images/alianzas/a5.jpg";
import alianza6 from "../assets/images/alianzas/a6.jpg";
import alianza7 from "../assets/images/alianzas/a7.jpg";
import alianza8 from "../assets/images/alianzas/a8.jpg";
import alianza9 from "../assets/images/alianzas/a9.jpg";
import alianza10 from "../assets/images/alianzas/a10.jpg";
import alianza11 from "../assets/images/alianzas/a11.jpg";
import alianza12 from "../assets/images/alianzas/a12.jpg";
import alianza13 from "../assets/images/alianzas/a13.jpg";
import alianza14 from "../assets/images/alianzas/a14.jpg";
import alianza15 from "../assets/images/alianzas/a15.jpg";
import alianza16 from "../assets/images/alianzas/a16.jpg";
import alianza17 from "../assets/images/alianzas/a17.jpg";

// import cert1 from '../assets/images/certificaciones/c1.jpg'
import cert2 from "../assets/images/certificaciones/cavsm.jpg";
import cert3 from "../assets/images/certificaciones/c3.jpg";
import cert4 from "../assets/images/certificaciones/c4.jpg";
// import cert5 from '../assets/images/certificaciones/c5.jpg'
import cert6 from "../assets/images/certificaciones/c6.jpg";
// import cert7 from '../assets/images/certificaciones/c7.jpg'
import cert8 from "../assets/images/certificaciones/c8.jpg";

import {
  LuBuilding,
  LuAmbulance,
  LuHospital,
  LuBriefcaseMedical,
} from "react-icons/lu";

export const clientData = [
  {
    image: team2,
    orden: 0,
    name: "Guillermo Barrera", //ok
    profesion: "",
    desc: "Mi hijo comenzó con un dolor agudo que resultó en apendicitis, por lo cual lo llevé a urgencias. El día sábado se programó la cirugía y todo salió muy bien. La atención por parte del personal siempre fue de lo mejor, extiendo una felicitación a todo el equipo porque fueron muy serviciales y amables. ¡Gracias de corazón!",
    tag: "Atención Médica",
    rate: [
      "mdi mdi-star",
      "mdi mdi-star",
      "mdi mdi-star",
      "mdi mdi-star",
      "mdi mdi-star",
    ],
  },
  {
    image: team3,
    orden: 1,
    name: "Edith Arianne Estrada Chavarria", //ok
    profesion: "",
    desc: "Quiero externar mi felicitación por el trabajo del equipo de Laboratorio, por las amables atenciones que tuvieron al caso de mi pequeña hija de 3 años de edad en aquel momento. La atención que me brindaron fue extraordinaria y la calidad humana que mostraron con mi pequeña inexplicable, no quise dejar desapercibido el reconocimiento a su gran labor, quiero hacer extensiva la felicitación de estos profesionales de la salud con los que cuenta el hospital.",
    tag: "Calidez Humana",
    rate: [
      "mdi mdi-star",
      "mdi mdi-star",
      "mdi mdi-star",
      "mdi mdi-star",
      "mdi mdi-star",
    ],
  },
  {
    image: team5,
    orden: 2,
    name: "Juana Patricia Pérez Gutiérrez", //ok
    profesion: "",
    desc: "Yo me he realizado estudios, mi familia se ha realizado procedimientos quirúrgicos aquí y siempre hemos sido muy bien atendidos. Para mi todos los servicios son de muy buena calidad.",
    tag: "Excelencia Médica",
    rate: [
      "mdi mdi-star",
      "mdi mdi-star",
      "mdi mdi-star",
      "mdi mdi-star",
      "mdi mdi-star",
    ],
  },
  {
    image: team2,
    orden: 3,
    name: "Sayra Velázquez González", //ok
    profesion: "",
    desc: "Cuentan con personal capacitado y las instalaciones siempre de primera clase, siempre encuentras cualquier tipo de estudio. Todo muy bien, ¡Felicidades!",
    tag: "Infraestructura",
    rate: [
      "mdi mdi-star",
      "mdi mdi-star",
      "mdi mdi-star",
      "mdi mdi-star",
      "mdi mdi-star",
    ],
  },
  {
    image: team2,
    orden: 4,
    name: "Mario Alderete García", //ok
    profesion: "",
    desc: "Excelente staff médico e instalaciones. Personal muy amable con muy buena actitud de servicio y profesionalismo. Agradecemos la atención de todo el personal de las áreas con las que interactuamos.",
    tag: "Profesionalismo",
    rate: [
      "mdi mdi-star",
      "mdi mdi-star",
      "mdi mdi-star",
      "mdi mdi-star",
      "mdi mdi-star",
    ],
  },
  {
    image: team2,
    orden: 5,
    name: "Francisco León Loza Mata", //ok
    profesion: "",
    desc: "La atención personalizada ágil y amable desde la recepción con las secretarias hasta los doctores que examinaron al paciente. Respondiendo a todas nuestras dudas, amables y empáticos, dar un diagnóstico certero y de una forma muy comprensible. Felicitaciones desde USA, Texas, es agradable ver que México no se queda atras en la vanguardia y excelente servicio médico.",
    tag: "Vanguardia",
    rate: [
      "mdi mdi-star",
      "mdi mdi-star",
      "mdi mdi-star",
      "mdi mdi-star",
      "mdi mdi-star",
    ],
  },
];

// {
//     image: cert1,
//     name: 'cert1',
// }, {
//     image: cert2,
//     name: 'cert2',
// },
// {
//     image: cert7,
//     name: 'cert7',
// },
export const certificacionesData = [
  {
    image: cert2,
    name: "cert2",
  },
  {
    image: cert3,
    name: "cert3",
  },
  {
    image: cert4,
    name: "cert4",
  },
  {
    image: cert8,
    name: "cert8",
  },
  {
    image: cert6,
    name: "cert6",
  },
];

export const alianzasData = [
  {
    image: alianza1,
    name: "alianza1",
  },
  {
    image: alianza2,
    name: "alianza2",
  },
  {
    image: alianza3,
    name: "alianza3",
  },
  {
    image: alianza4,
    name: "alianza4",
  },
  {
    image: alianza5,
    name: "alianza5",
  },
  {
    image: alianza6,
    name: "alianza6",
  },
  {
    image: alianza7,
    name: "alianza7",
  },
  {
    image: alianza8,
    name: "alianza8",
  },
  {
    image: alianza9,
    name: "alianza9",
  },
  {
    image: alianza10,
    name: "alianza10",
  },
  {
    image: alianza11,
    name: "alianza11",
  },
  {
    image: alianza12,
    name: "alianza12",
  },
  {
    image: alianza13,
    name: "alianza13",
  },
  {
    image: alianza14,
    name: "alianza14",
  },
  {
    image: alianza15,
    name: "alianza15",
  },
  {
    image: alianza16,
    name: "alianza16",
  },
  {
    image: alianza17,
    name: "alianza17",
  },
];

export const allbranchesData = [
  {
    id: 1,
    title: "Hospital Centro",
  },
  {
    id: 2,
    title: "Hospital Puerto Interior",
  },
  {
    id: 3,
    title: "Laboratorio Paseo del Moral",
  },
];

export const blogData = [
  {
    id: 1,
    image: blog1,
    tag: "Salud",
    title: "La prevención es clave en la medicina moderna",
    desc: "Aprende cómo acceder rápidamente a atención médica profesional.",
    date: "13 Sept 2024",
  },
  {
    id: 2,
    image: blog2,
    tag: "Salud Pública",
    title: "Los confinamientos reducen la búsqueda de atención médica",
    desc: "Exploramos el impacto de los confinamientos en la salud pública.",
    date: "29 Nov 2024",
  },
  {
    id: 3,
    image: blog3,
    tag: "Educación Médica",
    title: "Curso de investigación médica para doctores",
    desc: "Oportunidades de formación continua para el personal médico.",
    date: "29 Dic 2024",
  },
  {
    id: 4,
    image: blog4,
    tag: "Tecnología",
    title: "Comparación de congeladores de nitrógeno y mecánicos",
    desc: "Conoce las ventajas de cada tipo de congelador en medicina.",
    date: "13 Mar 2024",
  },
  {
    id: 5,
    image: blog5,
    tag: "Consejos de Salud",
    title: "La importancia de usar ropa adecuada",
    desc: "Descubre cómo la vestimenta influye en la salud y seguridad.",
    date: "5 May 2024",
  },
  {
    id: 6,
    image: blog6,
    tag: "Salud",
    title: "Cómo el virus afecta a la salud facial",
    desc: "Analizamos los efectos del virus en la apariencia facial.",
    date: "19 Jun 2024",
  },
  {
    id: 7,
    image: blog7,
    tag: "Investigación",
    title: "Investigación sobre el coronavirus en laboratorio",
    desc: "Actualización sobre los avances en estudios del COVID-19.",
    date: "20 Jun 2024",
  },
  {
    id: 8,
    image: blog8,
    tag: "Nutrición",
    title: "Uso de la espectroscopía para evaluar la calidad de los alimentos",
    desc: "Innovación en la medición de calidad alimentaria para la salud.",
    date: "31 Ago 2024",
  },
  {
    id: 9,
    image: blog9,
    tag: "Higiene",
    title: "Debes lavar tus manos durante 20 segundos",
    desc: "Consejos de higiene para protegerte y proteger a otros.",
    date: "1 Sept 2024",
  },
];

export const servicioData = [
  {
    id: 1,
    image: servicio,
    image1: servicio,
    image2: servicios1,
    image3: servicios2,
    image4: servicios3,
    tag: "Prevención",
    title: "La prevención es clave en la medicina moderna",
    desc: "Aprende cómo acceder rápidamente a atención médica profesional.",
    date: "13 Sept 2024",
  },
];

export const hospitalServicesData = [
  {
    id: 1,
    image: servicios1,
    tag: "Hospital",
    title: "Laboratorio Clínico",
    desc: "Análisis completos y precisos para apoyar el diagnóstico médico.",
    date: "1st Jan 2024",
  },
  {
    id: 2,
    image: servicios2,
    tag: "Hospital",
    title: "Cuidados Intensivos",
    desc: "Atención especializada y monitoreo constante para pacientes críticos.",
    date: "15th Feb 2024",
  },
  {
    id: 3,
    image: servicios3,
    tag: "Maternidad",
    title: "Salud Materna y Partos",
    desc: "Servicios integrales para un embarazo y parto seguros.",
    date: "10th Mar 2024",
  },
  {
    id: 4,
    image: servicios1,
    tag: "Hospital",
    title: "Urgencias",
    desc: "Atención inmediata para emergencias médicas de cualquier tipo.",
    date: "25th Apr 2024",
  },
  {
    id: 5,
    image: servicios2,
    tag: "Hospital",
    title: "Cirugía General",
    desc: "Procedimientos quirúrgicos seguros y efectivos para diversas patologías.",
    date: "5th May 2024",
  },
  {
    id: 6,
    image: servicios3,
    tag: "Imagenología",
    title: "Radiología e Imágenes",
    desc: "Diagnóstico avanzado a través de estudios de imagen de alta precisión.",
    date: "30th Jun 2024",
  },
  {
    id: 7,
    image: servicios1,
    tag: "Hospital",
    title: "Pediatría",
    desc: "Cuidado especializado para la salud y bienestar de los niños.",
    date: "12th Jul 2024",
  },
  {
    id: 8,
    image: servicios2,
    tag: "Hospital",
    title: "Oncología",
    desc: "Diagnóstico y tratamiento integral de diferentes tipos de cáncer.",
    date: "20th Aug 2024",
  },
  {
    id: 9,
    image: servicios3,
    tag: "Hospital",
    title: "Rehabilitación y Fisioterapia",
    desc: "Servicios de recuperación y terapia física para mejorar la movilidad.",
    date: "5th Sep 2024",
  },
  {
    id: 10,
    image: servicios1,
    tag: "Hospital",
    title: "Cardiología",
    desc: "Cuidado especializado para el diagnóstico y tratamiento de enfermedades del corazón.",
    date: "10th Oct 2024",
  },
];

export const oneDoctor = [
  {
    id: 1,
    image: doctor3,
    name: "Dra. Sofía Martínez",
    specialty: "Ginecología y Obstetricia",
    desc: "Acompañamiento integral durante el embarazo y el parto.",
    contact: "ginecologia@hospital.com",
    phone: "+52 555 345 6789",
    social: [FiFacebook, FiInstagram, FiTwitter],
  },
];

export const medicalDirectory = [
  {
    id: 1,
    image: doctor6,
    name: "Dr. María López",
    specialty: "Cardiología",
    desc: "Especialista en enfermedades del corazón con más de 15 años de experiencia.",
    contact: "contacto@hospital.com",
    phone: "+52 555 123 4567",
    social: [FiFacebook, FiInstagram, FiTwitter],
  },
  {
    id: 2,
    image: doctor2,
    name: "Dr. Juan Pérez",
    specialty: "Pediatría",
    desc: "Cuida la salud de los más pequeños con un enfoque humano.",
    contact: "pediatria@hospital.com",
    phone: "+52 555 234 5678",
    social: [FiFacebook, FiInstagram, FiTwitter],
  },
  {
    id: 3,
    image: doctor3,
    name: "Dra. Sofía Martínez",
    specialty: "Ginecología y Obstetricia",
    desc: "Acompañamiento integral durante el embarazo y el parto.",
    contact: "ginecologia@hospital.com",
    phone: "+52 555 345 6789",
    social: [FiFacebook, FiInstagram, FiTwitter],
  },
  {
    id: 4,
    image: doctor4,
    name: "Dr. Carlos Fernández",
    specialty: "Traumatología",
    desc: "Experto en el diagnóstico y tratamiento de lesiones ortopédicas.",
    contact: "traumatologia@hospital.com",
    phone: "+52 555 456 7890",
    social: [FiFacebook, FiInstagram, FiTwitter],
  },
  {
    id: 5,
    image: doctor5,
    name: "Dra. Elena Ramírez",
    specialty: "Dermatología",
    desc: "Tratamiento especializado para enfermedades de la piel y cuidado estético.",
    contact: "dermatologia@hospital.com",
    phone: "+52 555 567 8901",
    social: [FiFacebook, FiInstagram, FiTwitter],
  },
  {
    id: 6,
    image: doctor1,
    name: "Dr. Javier Gómez",
    specialty: "Neurología",
    desc: "Diagnóstico y tratamiento de enfermedades del sistema nervioso.",
    contact: "demo@demo.com",
    phone: "+52 555 678 9012",
    social: [FiFacebook, FiInstagram, FiTwitter],
  },
  {
    id: 7,
    image: doctor7,
    name: "Dra. Laura Torres",
    specialty: "Oncología",
    desc: "Especialista en el tratamiento de diferentes tipos de cáncer.",
    contact: "demo@demo.com",
    phone: "+52 555 789 0123",
    social: [FiFacebook, FiInstagram, FiTwitter],
  },
  {
    id: 8,
    image: doctor8,
    name: "Dr. Andrés Castillo",
    specialty: "Urología",
    desc: "Diagnóstico y tratamiento de enfermedades del sistema urinario.",
    contact: "demo@demo.com",
    phone: "+52 555 890 1234",
    social: [FiFacebook, FiInstagram, FiTwitter],
  },
];

export const medicalPackagesData = [
  {
    id: 1,
    image: paquete1,
    tag: "Prevención",
    title: "Chequeo Básico de Salud",
    desc: "Un paquete completo de exámenes básicos para la evaluación general de la salud.",
    date: "1st Jan 2024",
  },
  {
    id: 2,
    image: paquete2,
    tag: "Maternidad",
    title: "Cuidado Integral para Embarazadas",
    desc: "Incluye consultas prenatales, ecografías y monitoreo especializado para un embarazo seguro.",
    date: "15th Feb 2024",
  },
  {
    id: 3,
    image: paquete3,
    tag: "Longevidad",
    title: "Evaluación Cardíaca Completa",
    desc: "Estudios detallados de función y salud cardíaca, ideal para pacientes de riesgo.",
    date: "10th Mar 2024",
  },
  {
    id: 4,
    image: paquete1,
    tag: "Desempeño",
    title: "Chequeo Ejecutivo Completo",
    desc: "Evaluación exhaustiva diseñada para profesionales que buscan un chequeo integral.",
    date: "25th Apr 2024",
  },
  {
    id: 5,
    image: paquete2,
    tag: "Prevención",
    title: "Control de Salud Infantil",
    desc: "Incluye consultas pediátricas, vacunación y seguimiento del desarrollo infantil.",
    date: "5th May 2024",
  },
  {
    id: 6,
    image: paquete3,
    tag: "Prevención",
    title: "Control de Salud adultos mayores",
    desc: "Incluye consultas, vacunación y seguimiento.",
    date: "5th May 2024",
  },
];

export const facilitiesEquipmentData = [
  {
    id: 1,
    image: instalaciones1,
    tag: "Instalación",
    title: "Quirófanos de Alta Tecnología",
    desc: "Equipados con lo último en tecnología para realizar cirugías seguras y precisas.",
    date: "1st Jan 2024",
  },
  {
    id: 2,
    image: instalaciones2,
    tag: "Instalación",
    title: "Unidad de Cuidados Intensivos (UCI)",
    desc: "Monitoreo avanzado y atención constante para pacientes en estado crítico.",
    date: "15th Feb 2024",
  },
  {
    id: 3,
    image: instalaciones3,
    tag: "Instalación",
    title: "Sala de Emergencias",
    desc: "Diseñada para brindar atención inmediata y eficiente en situaciones de emergencia.",
    date: "10th Mar 2024",
  },
  {
    id: 4,
    image: instalaciones1,
    tag: "Instalación",
    title: "Laboratorio Clínico Avanzado",
    desc: "Equipado con sistemas automatizados para análisis precisos y rápidos.",
    date: "25th Apr 2024",
  },
  {
    id: 5,
    image: instalaciones2,
    tag: "Instalación",
    title: "Área de Radiología e Imágenes",
    desc: "Cuenta con equipos de tomografía, resonancia magnética y ultrasonido.",
    date: "5th May 2024",
  },
  {
    id: 6,
    image: instalaciones3,
    tag: "Instalación",
    title: "Unidad de Cuidados Neonatales",
    desc: "Especializada en el cuidado y monitoreo de recién nacidos.",
    date: "30th Jun 2024",
  },
  {
    id: 7,
    image: instalaciones1,
    tag: "Instalación",
    title: "Salas de Recuperación",
    desc: "Confortables y equipadas para asegurar una recuperación segura y monitoreada.",
    date: "12th Jul 2024",
  },
  {
    id: 8,
    image: instalaciones2,
    tag: "Instalación",
    title: "Centro de Rehabilitación",
    desc: "Instalado con equipos especializados para terapia física y recuperación.",
    date: "20th Aug 2024",
  },
  {
    id: 9,
    image: instalaciones3,
    tag: "Instalación",
    title: "Farmacia Interna",
    desc: "Abastecida con medicamentos esenciales y de fácil acceso para los pacientes.",
    date: "5th Sep 2024",
  },
  {
    id: 10,
    image: instalaciones1,
    tag: "Instalación",
    title: "Habitaciones Privadas",
    desc: "Espacios diseñados para brindar confort y privacidad a los pacientes y sus familias.",
    date: "10th Oct 2024",
  },
];

export const footerSocial = [
  {
    icon: FiInstagram,
    title: "Instagram",
    link: "https://www.instagram.com/hospitalarandadelaparra",
  },
  {
    icon: FiFacebook,
    title: "Facebook",
    link: "https://www.facebook.com/HospitalArandaParra",
  },
  {
    icon: FiTwitter,
    title: "X/Twitter",
    link: "https://x.com/arandadelaparra",
  },
  {
    icon: FiLinkedin,
    title: "Linkedin",
    link: "https://www.linkedin.com/company/hospital-aranda-de-la-parra/",
  },
  {
    icon: FiYoutube,
    title: "Youtube",
    link: "https://www.youtube.com/@hospitalarandadelaparra/videos",
  },
  {
    icon: FiLink,
    title: "Linktr.ee",
    link: "https://linktr.ee/arandadelaparra",
  },
];

export const footerCompany = [
  {
    title: "Quiénes somos",
    link: "/quienessomos",
  },
  {
    title: "Directorio médico",
    link: "/directorio",
  },
  {
    title: "Servicios",
    link: "/servicios",
  },
  {
    title: "Contacto",
    link: "/contacto",
  },
];

export const footerLink2 = [
  {
    title: "Facturación",
    link: "/facturacion",
    target: "_self",
  },
  {
    title: "Aviso de privacidad",
    link: "/aviso-privacidad",
    target: "_self",
  },
];

export const counterData = [
  {
    icon: FiCheckCircle,
    title: "Años",
    posttitle: "+",
    value: "85",
  },
  {
    icon: LuBriefcaseMedical,
    title: "Especialistas",
    posttitle: "+",
    value: "150",
  },
  {
    icon: LuBuilding,
    title: "Consultorios médicos especializados",
    posttitle: "+",
    value: "154",
  },
  {
    icon: LuHospital,
    title: "Habitaciones de hospitalización",
    posttitle: "",
    value: "113",
  },
  {
    icon: LuAmbulance,
    title: "Especialidades",
    posttitle: "",
    value: "29",
  },
];
export const teamData = [
  {
    image: team1,
    name: "Dr. Carlos Guzmán Murillo",
    position: "Director Médico",
    social: [],
  },
  {
    image: team2,
    name: "Dr. José Alfredo Silva Hernández",
    position: "Gerente Médico Puerto Interior",
    social: [],
  },
  {
    image: team3,
    name: "Dr. Fernando Pegueros Gómez",
    position: "Gestor Médico",
    social: [],
  },
];

export const servicesData = [
  {
    image: s1,
    title: "Cardiología",
    desc: "Cuidado especializado del corazón y el sistema circulatorio.",
  },
  {
    image: s2,
    title: "Neurología",
    desc: "Diagnóstico y tratamiento de trastornos del sistema nervioso.",
  },
  {
    image: s3,
    title: "Ortopedia",
    desc: "Atención integral de los huesos, músculos y articulaciones.",
  },
  {
    image: s4,
    title: "Ginecología",
    desc: "Salud y cuidado especializado para la mujer.",
  },
  {
    image: s5,
    title: "Dermatología",
    desc: "Tratamiento de enfermedades y cuidado de la piel.",
  },
  {
    image: s6,
    title: "Urología",
    desc: "Salud del sistema urinario y reproductivo masculino.",
  },
  {
    image: s7,
    title: "Neurocirugía",
    desc: "Cirugía avanzada del cerebro y sistema nervioso.",
  },
  {
    image: s8,
    title: "Radiología",
    desc: "Diagnóstico preciso mediante imágenes médicas.",
  },
  {
    image: s9,
    title: "Neonatología",
    desc: "Cuidado especializado para recién nacidos.",
  },
  {
    image: s10,
    title: "Odontología",
    desc: "Cuidado completo de la salud bucal y dental.",
  },
];

export const recentPost = [
  {
    image: blog1,
    title: "La Importancia de la Prevención en Salud",
    date: "13 Marzo 2024",
  },
  {
    image: blog2,
    title: "Consejos para un Corazón Saludable",
    date: "5 Mayo 2024",
  },
  {
    image: blog3,
    title: "Cuidados Prenatales: Qué Debes Saber",
    date: "19 Junio 2024",
  },
  {
    image: blog1,
    title: "Hábitos Saludables para Fortalecer el Sistema Inmunológico",
    date: "10 Agosto 2024",
  },
  {
    image: blog2,
    title: "Cómo Manejar el Estrés de Manera Saludable",
    date: "20 Septiembre 2024",
  },
];

export const tagCloud = [
  "Salud",
  "Bienestar",
  "Prevención",
  "Nutrición",
  "Ejercicio",
  "Cuidado Infantil",
  "Maternidad",
  "Corazón",
  "Salud Mental",
  "Inmunología",
];
